import type { CheckoutRes } from "~/types/checkout"
import { useQuery } from "@tanstack/vue-query"
import type { Ref } from "vue"

export function useCheckoutPolling(
  hasTimedOut: Ref<boolean>,
  interval: number,
  enabled: Ref<boolean>,
) {
  const sessionId = useVippsCheckoutSessionId()

  const isQueryEnabled = computed(
    () => enabled.value && !hasTimedOut.value && !!sessionId.value,
  )

  const api = useApiClients()

  const query = useQuery({
    queryKey: ["checkout", sessionId],
    enabled: isQueryEnabled,
    queryFn: () => api.ecommerce<CheckoutRes>(`/rest/checkout/${sessionId.value}`),
    refetchInterval: query => {
      // TODO: Are there other states that should be checked here?
      if (
        query.state.data?.sessionStatus === "NEW" ||
        query.state.data?.sessionStatus === "AUTHORIZED"
      ) {
        return interval
      }

      return false
    },
    select: data => data?.sessionStatus === "REJECTED",
  })

  const isPolling = computed(
    () => isQueryEnabled.value && query.data.value === undefined,
  )

  return {
    data: query.data,
    error: query.error,
    isLoading: isPolling,
  }
}
